import React, {Component} from "react"
import PropTypes from "prop-types"
import onClickOutside from "react-onclickoutside"

import {Icon} from "~/components/"

class SelectDropdown extends Component {
  constructor(props) {
    super(props)

    this.state = {optionsVisible: false}
  }

  handleClickOutside(event) {
    this.setState({optionsVisible: false})
  }

  showOptions(event) {
    this.setState({optionsVisible: true})
  }

  onClick(event, option) {
    event.stopPropagation()
    this.setState({optionsVisible: false})
    this.props.onSelect(option)
  }

  render() {
    return (
      <label
        className="sh-field-select"
        htmlFor={this.props.name}
        onClick={() => !this.props.disabled && this.showOptions()}
      >
        {this.props.label && <span>{this.props.label}</span>}

        <div className="inner">
          <div className="value">{this.props.value}</div>
          <Icon i="chevron-down" />

          <div className="options" hidden={!this.state.optionsVisible}>
            {this.props.options.map((option, index) => (
              <div key={index} onClick={event => this.onClick(event, option)}>
                {option.name}
              </div>
            ))}
          </div>
        </div>
      </label>
    )
  }
}

SelectDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.boolean
}

export default onClickOutside(SelectDropdown)



// WEBPACK FOOTER //
// ./src/components/SelectDropdown.js